import { StatutDisplay } from "../components/gestionDesAbsencesV2/listeConge/listeConge";
import { EtatAbsencesEnum } from "../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { CardInformationsByType, ICardInformations } from "../config/Absences.config";
import { CompteursAbsenceV2Dto } from "../dto/GenApi.iNotPaie.Dto/CompteursAbsenceV2Dto";
import { TypeCongeCompteurEnum } from "../dto/GenApi.iNotPaie.Dto/TypeCongeCompteurEnum";

export const plageHoraire = {
    matin: "M",
    apresMidi: "A"
};

// Configuration de base des classes et icônes
const baseConfig = {
    attenteValidation: {
        classe: "attente-validation",
        icon: "ri-time-fill"
    },
    attenteAnnulation: {
        classe: "attente-annulation",
        icon: "ri-time-fill"
    },
    valide: {
        classe: "valide",
        icon: "ri-check-fill"
    },
    calcule: {
        classe: "calcule",
        icon: "ri-check-fill"
    },
    annule: {
        classe: "annule",
        icon: "ri-delete-bin-7-fill"
    },
    refuse: {
        classe: "refuse",
        icon: "ri-close-large-line"
    },
    pris: {
        classe: "pris",
        icon: "ri-calendar-line"
    }
};

// Liste des statuts pour le side panel historique
export const listeStatutsHistorique: StatutDisplay[] = [
    {
        statut: [EtatAbsencesEnum.EnAttenteValidationGestionnaire, EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_1],
        ...baseConfig.attenteValidation,
        description: "En attente de validation N1"
    },
    {
        statut: [EtatAbsencesEnum.EnAttenteValidationResponsableNiveau_2],
        ...baseConfig.attenteValidation,
        description: "En attente de validation N2"
    },
    {
        statut: [EtatAbsencesEnum.Valide, EtatAbsencesEnum.Calcule],
        ...baseConfig.valide,
        description: "Validé"
    },
    {
        statut: [EtatAbsencesEnum.Cloture],
        ...baseConfig.pris,
        description: "Pris"
    },
    {
        statut: [EtatAbsencesEnum.Annule],
        ...baseConfig.annule,
        description: "Annulé"
    },
    {
        statut: [EtatAbsencesEnum.Refuse],
        ...baseConfig.refuse,
        description: "Refusé"
    },
    {
        statut: [EtatAbsencesEnum.EnAttenteAnnulationGestionnaire, EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1],
        ...baseConfig.attenteAnnulation,
        description: "En attente d'annulation N1"
    },
    {
        statut: [EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2],
        ...baseConfig.attenteAnnulation,
        description: "En attente d'annulation N2"
    }
];

/**
 * Mappe CompteursAbsenceV2Dto en ICardInformations en fonction du type d'absence
 * @param data Le compteur d'absence
 * @param typeConge Le type d'absence
 * @returns La data pour la carte
 */
export function mapCompteur(data: CompteursAbsenceV2Dto, typeConge: TypeCongeCompteurEnum): ICardInformations {
    const originalData = CardInformationsByType[typeConge];

    // Créer une copie profonde de l'objet pour éviter le partage de référence
    const cardInformations: ICardInformations = {
        title: originalData.title,
        backgroundColor: originalData.backgroundColor,
        data: {
            joursRestants: data.Restant,
            joursRestantsColor: originalData.data.joursRestantsColor,
            joursAcquis: data.Acquis,
            joursAcquisColor: originalData.data.joursAcquisColor,
            joursPoses: data.Poses,
            joursPosesColor: originalData.data.joursPosesColor,
            joursPris: data.Pris,
            joursPrisColor: originalData.data.joursPrisColor
        }
    };

    return cardInformations;
}




// WEBPACK FOOTER //
// ./src/Helper/absencesHelper.ts